import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

interface ScMenuProps {
  isMobile: boolean;
}

export const ScMenuDesktop = styled.ul<ScMenuProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0 4px;
  gap: 20px;

  @media (${device.mobile}) {
    padding: 0px 12px;
    gap: 24px;
  }

  & > li {
    & > a,
    & > button {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      background: none;
      border: none;
      padding: 0;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      color: ${({ theme }) => theme.grayColor1};
      text-decoration: none;
      cursor: pointer;
      text-align: left;

      & > div:first-child {
        display: inline-flex;
      }

      .stroke-icon svg,
      .fill-icon svg {
        height: 20px;
        width: 20px;
        margin-right: 8px;
        flex-shrink: 0;
        object-fit: contain;
      }
      @media (hover: hover) {
        &:hover {
          color: ${({ theme }) => theme.whiteColor};

          & > .stroke-icon svg path {
            stroke: url(#green-gradient);
          }

          & > .fill-icon svg path {
            fill: url(#green-gradient);
          }
        }
      }

      @media (${device.mobile}) {
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0.01em;

        svg {
          margin-right: 12px;
        }
      }
    }

    &.active {
      & > a,
      & > button {
        color: ${({ theme }) => theme.whiteColor};

        @media (hover: hover) {
          &:hover {
            color: ${({ theme }) => theme.whiteColor};
          }
        }

        & > .stroke-icon svg path {
          stroke: url(#green-gradient);
        }

        & > .fill-icon svg path {
          fill: url(#green-gradient);
        }
      }
    }
  }
`;

export const ScNavIndicator = styled.span<{ top: number }>`
  position: absolute;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme }) => theme.greenColor};
  left: -12px;
  top: ${({ top }) => `${top}px`};
  transform: translateY(-50%);
  transition: all 0.6s ease-in-out;
`;

export const ScNavBadge = styled.div<{ withOpacity?: boolean }>`
  position: absolute;
  display: inline-block;
  overflow: hidden;
  width: 20px;
  height: 20px;
  margin-left: 4px;
  flex-shrink: 0;
  right: 0;

  & > .bg {
    position: absolute;
    border-radius: 8px;
    inset: 0;
    background: ${({ theme, withOpacity = true }) =>
      `linear-gradient(90deg, ${hexToRGB(
        theme.greenColor,
        withOpacity ? 0.2 : 1
      )} 0%, ${hexToRGB(theme.marineColor, withOpacity ? 0.2 : 1)} 100%)`};
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 8px;
      padding: 2px;
      -webkit-mask: ${({ theme }) =>
        `linear-gradient(${theme.whiteColor} 0 0) content-box, linear-gradient(${theme.whiteColor} 0 0)`};
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      background: ${({ theme }) =>
        `linear-gradient(90deg, ${theme.greenColor} 0%, ${theme.marineColor} 100%)`};
    }
  }

  & > .content {
    position: relative;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    height: 100%;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    color: ${({ theme }) => theme.whiteColor};
    z-index: 1;

    svg {
      margin: 0;
    }
  }

  @media (${device.mobile}) {
    position: relative;
  }
`;
